import { useRef, useState } from "react";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
import { EmptyExtCalling, IVFollowupoc, Table } from "./Table";
import { Form } from "./Form";

export interface IModal {
    singleData: IVFollowupoc,
    open: boolean
}

export const FollowUpPoc = (permissions: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyExtCalling, open: false });
    };

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} HidePenFollowup={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>

            <Table hideDialog={hideDialog} permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}